import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LinkService } from '@shared/services/link.service';
export interface HeaderActionButton {
  button: {
    icon: string,
    fontAwesomeIcon?: boolean,
    label: string,
    raised?: boolean
  }
  action: Function
}
@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})

export class PageHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() backgroundUrl: string;
  @Input() additionalActions: HeaderActionButton[];
  datePickerStartDate: Date;
  datePickerEndDate: Date;
  datePickerMode: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router
  ) {

  }

  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe(params => {
      this.datePickerStartDate = params.dateFrom ? new Date(parseInt(params.dateFrom)) : null;
      this.datePickerEndDate = params.dateTo ? new Date(parseInt(params.dateTo)) : null;
      this.datePickerMode = params.timePickerMode || null;
    })
  }
  openHelp(): void {
    window.open('http://help.spaces.wondavr.com/en/articles/3294026-analytics-dashboard');
  }
  onTimePeriodChange(options: { date_from: Date, date_to: Date, timePickerMode: string }) {
    const params: Params = { dateFrom: options.date_from && options.date_from.getTime() || null, dateTo: options.date_to && options.date_to.getTime() || null, timePickerMode: options.timePickerMode };
    this._router.navigate([], {
      relativeTo: this._activatedRoute,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }
  performAction(actionButton: HeaderActionButton): void {
    if (typeof actionButton.action !== 'function') return;
    actionButton.action.call(this);
  }

}
